import React from "react";
import { connect } from "react-redux";
import PtsChart from "./components/PtsChart";
import Header from "./components/Header";
import TimePicker from "./components/TimePicker";
import Loading from "./components/Loading";
import { startOfDay } from "date-fns";
import "./styles/base/App.css";

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showTimePicker: false,
      interval: 300,
      pickedDate: startOfDay(new Date()),
      firstOfTime: startOfDay(new Date()),
      firstOfTimeInPlay: startOfDay(new Date()),
      endOfTime: startOfDay(new Date()),
    };
  }

  toggleTimePicker = () => {
    this.setState((prevState) => ({
      showTimePicker: !prevState.showTimePicker,
    }));
  };

  getPickedTime = (value) => {
    this.setState(() => ({
      firstOfTime: value[0],
      firstOfTimeInPlay: value[0],
      endOfTime: value[1],
    }));
  };

  getPickedDate = (value) => {
    this.setState(() => ({
      pickedDate: value,
    }));
  };

  getInterval = (value) => {
    this.setState(() => ({
      interval: value,
    }));
  };

  getFirstOfTimeInPlay = (value) => {
    this.setState(() => ({
      firstOfTimeInPlay: value,
    }));
  };

  render() {
    const isDtatFetched = this.props.datacenters;
    let jsx = [];
    if (isDtatFetched) {
      jsx = (
        <PtsChart
          data={this.chartData}
          bgcolor="#eee"
          className="space"
          datacenters={this.props.datacenters}
          connections={this.props.connections}
          colorMap={["#48466d", "#3fc1c9", "#fc5185", "#9896f1", "#e0f9b5"]}
          style={{ filter: this.state.showTimePicker ? "blur(5px)" : "" }}
        />
      );
    }
    return (
      <div className="App" style={{ textAlign: "left" }}>
        {jsx}
        <Header
          logoSrc="images/dc-logo.svg"
          toggleTimePicker={this.toggleTimePicker}
          firstOfTime={this.state.firstOfTime}
          firstOfTimeInPlay={this.state.firstOfTimeInPlay}
          interval={this.state.interval}
          endOfTime={this.state.endOfTime}
          getFirstOfTimeInPlay={this.getFirstOfTimeInPlay}
        />
        {this.state.showTimePicker && (
          <TimePicker
            pickedDate={this.state.pickedDate}
            getPickedTime={this.getPickedTime}
            getPickedDate={this.getPickedDate}
            toggleTimePicker={this.toggleTimePicker}
            getInterval={this.getInterval}
            firstOfTime={this.state.firstOfTime}
            interval={this.state.interval}
            endOfTime={this.state.endOfTime}
          />
        )}
        {this.props.fetchInProgress && <Loading />}
      </div>
    );
  }
}

const formatByCCode = (dcs) => {
  const formatedData = {};
  dcs.forEach((el) => {
    if (!formatedData[el.country_code]) {
      formatedData[el.country_code] = {};
      formatedData[el.country_code].dcs = [];
    }
    formatedData[el.country_code].dcs.push(el);
  });
  return { ...formatedData, count: dcs.length };
};

const mapStateToProps = (state) => ({
  datacenters: state.dc.dcs ? formatByCCode(state.dc.dcs) : false,
  connections: state.dc.connectivity,
  fetchInProgress: state.fetchInProgress,
});

export default connect(mapStateToProps)(App);
